module.exports = __webpack_public_path__ + "fonts/NoirPro-Bold.9dbcc95d.woff";